
// State Management for Subscription Funnel

// Internal State Variables
window.currentStep = 'category-selection';
window.currentFlow = 'bottled'; // 'bottled' | 'matrix'
window.isCalculatorPath = false;
window.isExistingClient = false;
window.isClientValidated = false;
window.selectedPlan = null;  // 'flexible' | 'monthly'
window.currentBottles = 6;
window.currentProductInfo = null;
window.skipCheckClient = false;
window.currentPreContractDataConfig = null;
window.currentProductSteps = null; // Array de strings
window.stepHistory = [];
window.currentBottledProduct = 'core';
window.currentMatrixProduct = 'core';

// Configuration
window.baseSteps = ['category-selection', 'product-selection'];
window.defaultProductSteps = [
    'product-detail',
    'plan-selection',
    'savings-calculator',
    'elevator-check',
    'pre-checkout',
    'contract-data',
    'validation',
    'installation-schedule',
    'thank-you'
];

// Helper to normalize step names (aliasing old to new)
window.sfNormalizeStep = function(step) {
    if (!step) return step;
    const s = step.trim();
    if (s === 'monthly-config') return 'elevator-check';
    if (s === 'checkout') return 'contract-data';
    return s;
};

// Initialize State from URL
(function initializeState() {
    const urlParams = new URLSearchParams(window.location.search);
    const rawStep = urlParams.get('step');
    let urlStep = rawStep ? rawStep.trim() : null;
    urlStep = window.sfNormalizeStep(urlStep);
    
    const urlProduct = urlParams.get('product'); // handle
    const urlFlow = urlParams.get('flow');

    const urlFunnelConfig = urlParams.get('funnel_config');
    const urlPreCheckoutConfig = urlParams.get('pre_checkout_config');

    const allValidSteps = [...window.baseSteps, ...window.defaultProductSteps, 'product-selection', 'calculator'];
    if (urlStep && allValidSteps.includes(urlStep)) {
        console.log('Using URL Step:', urlStep);
        window.currentStep = urlStep;

        // Auto-fix URL if it was a legacy name
        if (urlParams.get('step') && urlParams.get('step') !== urlStep) {
            urlParams.set('step', urlStep);
            const newUrl = `${window.location.pathname}?${urlParams.toString()}${window.location.hash}`;
            try { window.history.replaceState(null, '', newUrl); } catch(e) {}
        }
    }

    if (urlProduct) {
        // Pre-set product info
        window.currentProductInfo = {
            handle: urlProduct, // Critical for robust matching
            title: urlParams.get('title') || 'Producto',
            price: urlParams.get('price') || '',
            image: urlParams.get('image') || ''
        };

        // Restore Client Check State if redirected
        const pIsClient = urlParams.get('is_client');
        const pSkipClient = urlParams.get('skip_client');

        if (pIsClient !== null) {
            // Convert string 'true'/'false' to boolean
            window.isExistingClient = (pIsClient === 'true');
            if (window.isExistingClient) {
                window.isClientValidated = true;
            }
        }

        if (pSkipClient === 'true') {
            window.skipCheckClient = true;
        }

        if (urlFunnelConfig) {
            try {
                const parsed = JSON.parse(decodeURIComponent(urlFunnelConfig));
                if (Array.isArray(parsed)) {
                    window.currentProductSteps = parsed.map(s => window.sfNormalizeStep(s) || s);
                }
            } catch (e) { console.error('Error parsing url funnel config', e); }
        }

        if (urlPreCheckoutConfig) {
            try {
                window.currentPreContractDataConfig = JSON.parse(decodeURIComponent(urlPreCheckoutConfig));
            } catch (e) { console.error('Error parsing url pre-checkout config', e); }
        }

        if (urlFlow) {
            window.currentFlow = urlFlow;
            if (window.currentFlow === 'bottled') {
                if (urlProduct.includes('touch')) window.currentBottledProduct = 'touch';
            } else {
                window.currentMatrixProduct = 'core';
            }
        }
    }

    console.log('SF State Initialized. Step:', window.currentStep);
})();

// Helper to get full step list based on state
window.getFullStepList = function () {
    const urlParams = new URLSearchParams(window.location.search);
    const urlProduct = urlParams.get('product');
    const rawStep = urlParams.get('step');
    const urlStep = window.sfNormalizeStep(rawStep ? rawStep.trim() : null);

    // 1. Determine Base Flow
    let flow = [];

    // If entering directly at savings-calculator, build a minimal flow starting there
    if (urlStep === 'savings-calculator' && !urlProduct) {
        flow = ['savings-calculator', 'elevator-check', 'pre-checkout', 'contract-data', 'validation', 'installation-schedule', 'thank-you'];
        return flow;
    }

    if (urlProduct) {
        flow = ['product-detail'];
    } else {
        flow = [...window.baseSteps]; // ['category-selection', 'product-selection']
    }

    // 2. Append Product-specific steps
    let productSteps = [];
    if (window.currentProductSteps && window.currentProductSteps.length > 0) {
        productSteps = [...window.currentProductSteps];
    } else {
        productSteps = [...window.defaultProductSteps];
    }

    // Filter out redundancy
    if (urlProduct) {
        productSteps = productSteps.filter(s => s !== 'product-detail');
    }

    // Custom IBBL Reordering Logic (Matrix)
    if (window.currentFlow === 'matrix') {
        const mIndex = productSteps.indexOf('elevator-check');
        if (mIndex !== -1) {
            productSteps.splice(mIndex, 1);
            const pIndex = productSteps.indexOf('pre-checkout');
            if (pIndex !== -1) {
                productSteps.splice(pIndex + 1, 0, 'elevator-check');
            } else {
                productSteps.push('elevator-check');
            }
        }
    }

    // Concat
    flow = flow.concat(productSteps);

    // Remove 'check-client' if skipped
    if (window.skipCheckClient) {
        flow = flow.filter(s => s !== 'check-client');
    }

    return flow;
};
